// Lib core
import Lib from './core'

// base
import './base/displayElem'
import './base/classes'
import './base/attributes'
import './base/events'
import './base/actions'
import './base/animate'

// components
import './components/dropdown'
import './components/modal'
import './components/tabs'
import './components/accordion'
import './components/carousel'

// services
import './services/api'

export default Lib
